import { render } from "./Info3.vue?vue&type=template&id=cb290440&scoped=true"
import script from "./Info3.vue?vue&type=script&lang=js"
export * from "./Info3.vue?vue&type=script&lang=js"

import "./Info3.vue?vue&type=style&index=0&id=cb290440&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb290440"]])

export default __exports__